import { useState } from 'react';
import { Modal } from '@rabbit/elements/shared-components';
import { useLocation } from 'react-router-dom';
import { ModalAddEditVendable } from '../components/organisms/ModalNewEditProduct/ModalTypes/ModalAddEditVendable';
import { VendableEditorProviderWrapper } from '@rabbit/bizproc/react';
import VendableDetailsTemplate from '../components/templates/VendableDetailsTemplate/VendableDetailsTemplate';
import { useTranslation } from 'react-i18next';
import ModalAddEditItem, {
  ModalAddEditItemKind,
} from '@rabbit/sage/components/organisms/ModalNewEditProduct/ModalAddEditItem.tsx';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface VendableDetailsViewProps {}

export function VendableDetailsView(props: VendableDetailsViewProps) {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const vendableId = location.pathname.split('/')[2];
  const [isEditProductModalOpen, setIsEditProductModalOpen] = useState(false);
  const [isNewEditModalOpen, setIsNewEditModalOpen] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState<string>();
  const [modalKind, setModalKind] = useState<ModalAddEditItemKind>();
  const [itemDetails, setItemDetails] = useState<any>();
  const { t } = useTranslation();
  const handleEditModal = (
    kind: ModalAddEditItemKind,
    title: string,
    itemDetails?: any
  ) => {
    setModalKind(kind);
    setModalTitle(title);
    setIsNewEditModalOpen(true);
    setItemDetails(itemDetails);
  };

  return (
    <VendableEditorProviderWrapper>
      <VendableDetailsTemplate
        vendableId={vendableId}
        setIsEditProductModalOpen={setIsEditProductModalOpen}
        handleEditModal={handleEditModal}
      />

      {isNewEditModalOpen && (
        <div>
          <ModalAddEditItem
            handleClose={() => setIsNewEditModalOpen(false)}
            handleDelete={() => setIsConfirmationModalOpen(true)}
            handleSubmit={() => void 0}
            itemDetails={itemDetails}
            kind={modalKind}
            title={modalTitle}
          />
        </div>
      )}

      {isEditProductModalOpen && (
        <Modal
          kind={'generic'}
          className="h-fit max-w-[90vw] rounded-md bg-white md:w-3/4 lg:w-2/4"
          settings={{
            handleClose: () => setIsEditProductModalOpen(false),
            title: t('general.editProduct'),
            loading: loading,
          }}
        >
          <ModalAddEditVendable
            handleClose={() => setIsEditProductModalOpen(false)}
            vendableId={vendableId}
            setLoading={setLoading}
          />
        </Modal>
      )}
    </VendableEditorProviderWrapper>
  );
}

export default VendableDetailsView;
